const keysOf = <T extends object>(o: T) => Object.keys(o) as (keyof typeof o)[];

export const sizes = {
  tablet: '64rem',
  desktop: '85rem',
} as const;

const minWidthQuery = (width: string) => `@media (min-width: ${width})`;

export const from = keysOf(sizes).reduce(
  (acc, key) => ({
    ...acc,
    [key]: minWidthQuery(sizes[key]),
  }),
  {} as { [key in keyof typeof sizes]: string },
);
